import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guarda de autenticação para proteger rotas privadas.
 * Verifica se o usuário possui um token válido antes de permitir o acesso.
 * Se o token for inválido ou estiver ausente, o usuário será redirecionado para a página de login.
 */

export const authGuard: CanActivateFn = () => {
  
  // Obtém instâncias do AuthService e do Router
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verifica se o token do usuário é válido e não expirou
  if (authService.isAuthenticated()) {
    
    // Verifica se o usuário é Guest
    const userRole = authService.getUserRole();
    if (userRole === 'Guest') {
      // Guests não podem acessar o painel administrativo
      router.navigate(['/guest/restricted']);
      return false;
    }
    
    return true; // Permite o acesso à rota protegida

  } else {

    // Caso o token seja inválido ou tenha expirado, o usuário é redirecionado para o login
    authService.logoutAndClear();           // Remove o token inválido do armazenamento
    router.navigate(['/auth/login']);       // Redireciona para a página de login
    return false;                           // Bloqueia o acesso à rota protegida

  }
};
